module.exports = __webpack_public_path__ + "static/microsoft_365_4-606c78d9c7a3230219f2e74eff2751ff.png";